export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YLJvilss6yLUrwA.e06baf3e.woff2";